import React, { memo } from "react";
import { Box, Typography } from "@mui/material";

const formatTwoDecimals = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "N/A";
  return Number(value).toFixed(2);
};

const MetricPanel = ({ value, color, metaLabel }) => {
  const isMissing = value === null || value === undefined || isNaN(value);

  return (
    <Box
      sx={{
        minWidth: { xs: 108, sm: 132 },
        p: "16px",
        borderRadius: "12px",
        background: "var(--color-bg)",
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "2px",
      }}
    >
      <Typography
        className="tabular"
        sx={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: { xs: 14, sm: 16, lg: 18 },
          fontWeight: 700,
          lineHeight: 1,
          color: isMissing ? "var(--color-text-muted)" : color,
        }}
      >
        {isMissing ? "N/A" : `${formatTwoDecimals(value)}%`}
      </Typography>
      <Typography
        sx={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: {xs: 10, sm: 12},
          fontWeight: 700,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          color: "var(--color-text-muted)",
        }}
      >
        {metaLabel}
      </Typography>
    </Box>
  );
};

export default memo(MetricPanel);
